
import {  NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';

import { AuthorizationGuard } from 'common';

const ROUTES: Routes = [
    {
        path: "",
        canActivate: [AuthorizationGuard],
        loadChildren: () => import('./main-layout/main-layout.module').then((out) => out.MainLayoutModule)
    },
    {
        path: "Public",
        loadChildren: () => import('common').then(module => module.LoginLayoutModule),
    },
    {
        path: "viewer/:documentID",
        loadChildren: () => import('common').then(module => module.ViewerModule),
    },
]

@NgModule({
    declarations: [],
    imports: [
        RouterModule.forRoot(ROUTES, { preloadingStrategy: PreloadAllModules })
    ],
    exports: [
        RouterModule
    ],
  
})
export class AppRoutingModule { }
